import Profitability from '@/pages/admin/reports/workOrders/Profitability.vue';
import Overtime from '@/pages/admin/reports/workOrders/Overtime.vue';
import Taxes from '@/pages/admin/reports/invoices/Taxes.vue';
import TotalOverTime from '@/pages/admin/reports/workOrders/TotalOverTime.vue';
import LocationSearch from '@/pages/admin/reports/clientFeedbacks/LocationSearch.vue';
import DicksSportingGoodPerformance from '@/pages/admin/reports/clientFeedbacks/DicksSportingGoodPerformance.vue';
import Revenue from '@/pages/admin/reports/invoices/Revenue.vue';
import Technicians from '@/pages/admin/reports/users/Technicians.vue';
import RegionalManagers from '@/pages/admin/reports/users/RegionalManagers.vue';
import TechniciansForecast from '@/pages/admin/reports/users/TechniciansForecast.vue';
import RegionalManagerDashboard from '@/pages/admin/reports/users/RegionalManagerDashboard.vue';
import TechnicianDashboard from '@/pages/admin/reports/users/TechnicianDashboard.vue';
import CommissionReport from '@/pages/admin/reports/commissions/Report.vue';
import Incentive from '@/pages/admin/reports/workOrders/Incentive.vue';
import handlePaginationRouteProps from '@/utils/handlePaginationRouteProps.js';

export default [
  {
    path: 'reports/work_orders/profitability',
    name: 'work-orders-profitability-report',
    component: Profitability,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/work_orders/overtime',
    name: 'work-orders-overtime-report',
    component: Overtime,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/work_orders/incentive',
    name: 'work-orders-incentive-report',
    component: Incentive,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/invoices/taxes',
    name: 'invoices-taxes-report',
    component: Taxes,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/work_orders/total_over_time',
    name: 'work-orders-total-over-time',
    component: TotalOverTime,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/client_feedbacks/location_search',
    name: 'client-feedbacks-location-search',
    component: LocationSearch,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/client_feedbacks/dicks_sporting_goods_kpi',
    name: 'client-feedbacks-dicks-sporting-goods-kpi',
    component: DicksSportingGoodPerformance,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/invoices/revenue',
    name: 'invoices-revenue-report',
    component: Revenue,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/technicians/kpi',
    name: 'technicians-report',
    component: Technicians,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/technicians/regional_manager_kpi',
    name: 'regional-managers-report',
    component: RegionalManagers,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/technicians/forecast',
    name: 'technicians-forecast-report',
    component: TechniciansForecast,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/technicians/regional_manager/:id(\\d+)',
    name: 'regional-manager-report',
    component: RegionalManagerDashboard,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/technicians/:id(\\d+)',
    name: 'technician-report',
    component: TechnicianDashboard,
    props: handlePaginationRouteProps,
  },
  {
    path: 'reports/commissions/report',
    name: 'commissions-report',
    component: CommissionReport,
    props: handlePaginationRouteProps,
  },
];
